function initRapid() {
  let rapidInstance = null

  return ({tracked_mods = [], ...rest} = {}) => {
    if (typeof window === 'undefined' || !window.YAHOO || !window.YAHOO.i13n?.Rapid) return null

    if (rapidInstance) return rapidInstance

    rapidInstance = new window.YAHOO.i13n.Rapid({...rest, tracked_mods})
    
    rapidInstance._normalizeTar = (href) => {
      let tarObj = {
        tar: href,
        tar_uri: href,
      }

      if (typeof URL !== 'undefined') {
        const url = new URL(href)

        tarObj = {
          tar: url.origin,
          tar_uri: url.pathname,
        }
      }

      return tarObj
    }

    return rapidInstance
  }
}

export const getRapid = initRapid()
